export const FilterTypes = {
  broad: 'broad',
  narrow: 'narrow',
}

const commonCoreCurriculumToId = {
  Mathematics: 212,
  ELA: 213,
  Science: 215,
  'Social Studies': 236,
}

export const getFilterType = (filter) => {
  if (
    filter.standardIds?.length ||
    filter.questionType ||
    filter.depthOfKnowledge ||
    filter.authorDifficulty ||
    filter.collections?.length ||
    filter.status ||
    filter.tags?.length ||
    filter.authoredByIds?.length ||
    filter.createdAt ||
    filter.type ||
    (filter.curriculumId &&
      !Object.values(commonCoreCurriculumToId).includes(filter.curriculumId))
  ) {
    return FilterTypes.narrow
  }

  return FilterTypes.broad
}
